import React, { useState, useEffect, useContext } from "react";

//import css
import "./RecentPaymentsCards.scss";

//import icons
import { FaPercentage } from "react-icons/fa";
import { MdCreditScore } from "react-icons/md";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { fetchPayments } from "../../../../redux/slices/sliceActions";

//import context
import { MyContext } from "../../../../tenantsDashContext";
import PaymentConfirmationModal from "../Pc-and-Large-Screens/ApprovePaymentModal";

const RecentPaymentsCards = ({ selectedDate }) => {
  //check shared value from context
  const { sharedValue, rolesAssigned } = useContext(MyContext);

  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [paymentsReceived, setPaymentsReceived] = useState([]);

  useEffect(() => {
    if (property_id) {
      dispatch(fetchPayments({ property_id, token })).then((res) => {
        // Filter payments up to the current month and year
        const filteredPayments = filterPaymentsByMonth(
          res.payload.payments,
          selectedDate
        );
        setPaymentsReceived(filteredPayments);
        console.log("fetching payments", filteredPayments);
      });
    }
  }, [user]);

  const paymentData = {
    payments: paymentsReceived,
  };

  if (sharedValue === "Invoices") {
    paymentData.payments = paymentsReceived.filter(
      (payment) => payment.payment_status === 0
    );
  }
  // Initialize state with sample data

  const [visiblePayments, setVisiblePayments] = useState(3);
  const [expandedCardIndex, setExpandedCardIndex] = useState(null);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getPaymentStatus = (status) => {
    return status === 0 ? "Partial" : "Complete";
  };

  const handleSeeMore = () => {
    setVisiblePayments((prevVisiblePayments) => prevVisiblePayments + 5);
  };

  const handleHideAll = () => {
    setVisiblePayments(5);
  };

  const toggleExpandCard = (payment_id) => {
    setExpandedCardIndex(expandedCardIndex === payment_id ? null : payment_id);
  };

  //approve payment
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
  };

  const handleConfrim = () => {
    alert("Payment Approved");
    // const paymentId = parseInt(expandedPayment);
    // dispatch(confirmPayments({ paymentId, token })).then((res) => {
    //   dispatch(
    //     fetchPayments({ property_id, token })
    //   );
    // });

    console.log("cleared");
  };

  return (
    <div className="payments-container">
      {paymentData.payments.slice(0, visiblePayments).map((payment, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="card" onClick={() => toggleExpandCard(payment.payment_id)}>
            <div className="icon-and-description">
              <div className="icon">
                {getPaymentStatus(payment.invoice.payment_status) ===
                "Partial" ? (
                  <FaPercentage />
                ) : (
                  <MdCreditScore />
                )}
              </div>
              <div className="description-and-ammount">
                <div className="description">
                  {shortenString(payment.payment_narration)}
                </div>
                <div className="amount">{payment.amount}</div>
              </div>
            </div>
            <div className="date">{formatDate(payment.created_at)}</div>
          </div>

          {expandedCardIndex === payment.payment_id && (
            <div className="extra-info">
              <div className="extra-info-title">Transaction Details</div>
              <div className="details-and-title">
                <div className="tile">Invoice ID:</div>
                <div className="details"> {payment.invoice.invoice_id}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Rent Amount:</div>
                <div className="details"> {payment.rent_amount}</div>
              </div>
              <div className="details-and-title">
                <div className="tile"> Arrears Amount:</div>
                <div className="details"> {payment.arrears_amount}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Garbage Charge: </div>
                <div className="details">{payment.garbage_charge_amount}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Water Bill Amount:</div>
                <div className="details"> {payment.water_bill_amount}</div>
              </div>
              <div className="details-and-title">
                <div className="tile">Service Fee Amount:</div>
                <div className="details"> {payment.service_fee_amount}</div>
              </div>

              <div className="details-and-title">
                <div className="tile">Payment ID:</div>
                <div className="details"> {payment.payment_id}</div>
              </div>

              {payment.payment_status === 0 && (
                <>
                  <div>
                    {rolesAssigned?.approvePayments && (
                      <>
                        <div
                          style={{
                            backgroundColor: "#0B2C3C",
                            color: "white",
                            padding: "7px 10px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            marginTop: "10px",
                            fontSize: "14px",
                          }}
                          onClick={() => {
                            setIsOpen(true);
                          }}
                        >
                          Approve Payment
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      ))}

      {visiblePayments < paymentData.payments.length && (
        <div className="see-more-buttons-container">
          <button className="see-more-button" onClick={handleSeeMore}>
            See More
          </button>
        </div>
      )}

      {visiblePayments > 5 && (
        <div className="see-more-buttons-container">
          <button className="hide-all-button" onClick={handleHideAll}>
            Hide All
          </button>
        </div>
      )}



      <PaymentConfirmationModal isOpen={isOpen} paymentId={expandedCardIndex} onConfirm={handleConfrim} onCancel={closeModal} />
    
    </div>
  );
};

function shortenString(str) {
  if (str.length > 14) {
    return str.slice(0, 14) + "...";
  }
  return str;
}

const filterPaymentsByMonth = (payments, { month, year }) => {
  console.log("the month", month);

  const months = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };

  // Convert the provided month and year to integers
  const currentMonth = months[month]; // Assuming month is passed as a string like "08" or "12"
  const currentYear = parseInt(year, 10);

  console.log(
    "payment to filter",
    payments,
    "current month",
    currentMonth,
    "current year",
    currentYear
  );
  // Filter payments that are up to the provided month and year
  return payments.filter((payment) => {
    const paymentDate = new Date(payment.created_at);
    const paymentMonth = paymentDate.getMonth() + 1; // getMonth() returns 0-indexed month
    const paymentYear = paymentDate.getFullYear();

    // Return true if the payment's year is less than the current year,
    // or if it's the same year and the month is less than or equal to the current month.
    return (
      paymentYear < currentYear ||
      (paymentYear === currentYear && paymentMonth <= currentMonth)
    );
  });
};

export default RecentPaymentsCards;
